import m from "../../geodata/es2015/azerbaijanHigh";
window.am4geodata_azerbaijanHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/azerbaijanHigh.js
// module id = null
// module chunks = 